/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Multi-Touch Attribution — model contribution, comparison, path explorer. */
(function () {
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["multi-touch-attribution"] = "1.0.3"; } catch (e) {}
  var root, DATA=null;
  var CH={ "Direct":"#64748B","Organic Search":"#1FA463","Paid Search":"#F59E0B","Social":"#6366F1","Email":"#EC4899","Referral":"#3B82F6","Display":"#8B5CF6","Campaign":"#14B8A6","Affiliate":"#EF4444" };
  function col(c){ return CH[c]||"#94A3B8"; }
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }

  function load(){ GS.api("/plugin/multi-touch-attribution/stats?site="+encodeURIComponent(GS.site)+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){ if(r.ok&&r.data){ DATA=r.data; render(); } }); }
  /* Only the five models the <select> actually offers. An unknown value would leave renderModel
     with no data and blank the chart, so it is ignored and the default stands. */
  var MODELS = ["first", "last", "linear", "time_decay", "position"];

  /* Attribution models are the whole point of this page and the page never says what they are.
     "Linear 4.2" means nothing until someone tells you that the same conversion is being divided
     up five different ways — and that the models disagree BY DESIGN. That disagreement is the
     finding: if first-touch says Organic and last-touch says Email, both are true and they are
     answering different questions. */
  var MODEL_HELP = {
    first:      TR('multit.f2.first_touch_u2014_100_of_the_credi'),
    last:       TR('multit.f2.last_touch_u2014_100_to_the_last_i'),
    linear:     TR('multit.f2.linear_u2014_the_credit_split_even'),
    time_decay: TR('multit.f2.time_decay_u2014_more_credit_the_c'),
    position:   TR('multit.f2.position_based_40_20_40_u2014_40_t')
  };
  /* The chosen model is written to the URL (renderModel below) but was never read back, so a bookmarked
     or shared /multi-touch-attribution?model=position opened showing Linear — the link looked like it
     worked and quietly showed a different analysis. Validate against the options the select actually
     offers rather than trusting the parameter. */
  function currentModel() {
    var sel = q("model-sel");
    var want = null;
    if (window.GSLink && GSLink.read) {
      var r = GSLink.read({ model: "key" });
      want = r && r.model ? String(r.model) : null;
    }
    if (!want) {
      try { want = new URLSearchParams(location.search).get("model"); } catch (e) { want = null; }
    }
    if (sel && want) {
      var ok = false;
      for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === want) { ok = true; break; }
      if (ok && sel.value !== want) sel.value = want;      // keep the menu and the chart in agreement
    }
    return sel ? sel.value : (want || "linear");
  }

  var MODEL_NAMES = { first: TR('multit.g.first_touch'), last: TR('multit.g.last_touch'), linear: TR('multit.g.linear'),
                      time_decay: TR('multit.g.time_decay'), position: "Position-based" };
  function modelLabel(k) { return MODEL_NAMES[k] || String(k || ""); }
  function cmpLabel(k)   { return modelLabel(k); }

  function modelHelp(k) { return MODEL_HELP[k] || null; }
  function wireModelHelp() {
    var sel = q("model-sel"); if (!sel) return;
    function tip() { sel.title = modelHelp(sel.value) || ""; }
    tip(); sel.addEventListener("change", tip);
    var lab = q("model-note");
    if (lab) { function note() { lab.textContent = modelHelp(sel.value) || ""; } note(); sel.addEventListener("change", note); }
  }
  var _deepModelDone = false;
  function gsDeepModel() {
    if (_deepModelDone) return; _deepModelDone = true;      // only on the first paint, not every reload
    var v = null;
    if (window.GSLink) v = window.GSLink.read({ model: "key" }).model;   // "time_decay" keeps its underscore
    else { try { v = (String(new URLSearchParams(location.search).get("model") || "").toLowerCase().replace(/[^a-z0-9_-]/g, "")) || null; } catch (e) { v = null; } }
    var sel = q("model-sel");
    if (sel && v && MODELS.indexOf(v) >= 0) sel.value = v;
  }
  function render(){
    var d=DATA;
    q("k-conv").textContent=(d.total_conversions||0).toLocaleString();
    q("k-vis").textContent=(d.converters||0).toLocaleString();
    q("k-paths").textContent=((d.paths||[]).length).toLocaleString();
    var rw=q("k-rev-wrap"); if(d.revenue_mode && d.total_revenue>0){ rw.hidden=false; q("k-rev").textContent=(d.total_revenue||0).toLocaleString(undefined,{minimumFractionDigits:2}); } else rw.hidden=true;
    /* Deep link: /multi-touch-attribution?model=first|last|linear|time_decay|position.
       Applied HERE, not at init: renderModel needs DATA, which only exists once load() resolves.
       Setting the <select> first keeps the control and the chart in step. */
    gsDeepModel();
    renderModel(currentModel());
    renderComparison();
    renderPaths();
  }
  function renderModel(mo){
    wireModelHelp();
    if (window.GSLink) window.GSLink.write({ model: mo });
    var m=(DATA.models||{})[mo]; var host=q("model-bars");
    if(!m||!m.channels.length){ host.innerHTML='<div class="empty">'+TR('multit.no_attributed_conversions_in_this_range')+'</div>'; return; }
    /* Vertical columns, largest first. Horizontal rows read fine for one model, but the question people
       actually bring here is "which channel does this model credit more than that one?" — and that is a
       comparison between two bars, which the eye does best side by side at a shared baseline. */
    var chans = m.channels.slice().sort(function(a,b){ return (+b.credit||0)-(+a.credit||0); });
    chans = chans.slice(0, 10);

    /* The comparison model. All models arrive in the same payload, so this costs no request. */
    var cs = q("cmp-sel"), cmpKey = cs ? cs.value : "";
    if (cmpKey === mo) cmpKey = "";                       // comparing a model with itself says nothing
    var cmp = cmpKey ? ((DATA.models||{})[cmpKey]||null) : null;
    var cmpBy = {};
    if (cmp) (cmp.channels||[]).forEach(function(c){ cmpBy[c.channel] = c; });

    /* One scale across BOTH models, or the taller bar is just the one drawn against a smaller maximum. */
    var max = 1, total = 0;
    chans.forEach(function(c){ if(c.credit>max)max=c.credit; total+=(+c.credit||0); });
    if (cmp) (cmp.channels||[]).forEach(function(c){ if(c.credit>max)max=c.credit; });

    var cols = chans.map(function(c,i){
      var other = cmpBy[c.channel] || null;
      var h1 = Math.max(2, (c.credit / max) * 100);
      var h2 = other ? Math.max(2, (other.credit / max) * 100) : 0;
      /* Delta in percentage POINTS of share: credit counts are not comparable when the two models
         distribute different totals, but shares always are. */
      var d = other ? (Math.round(((+c.pct||0) - (+other.pct||0)) * 10) / 10) : null;
      var dCls = d === null ? "" : (d > 0.05 ? " up" : (d < -0.05 ? " down" : " flat"));
      var dTxt = d === null ? "" : ((d > 0 ? "+" : "") + d.toFixed(1) + "pp");
      var tip = esc(c.channel) + " \u2014 " + c.credit + " of " + (Math.round(total*100)/100) +
                " credited conversions (" + c.pct + "%)" +
                (other ? ("\n" + cmpLabel(cmpKey) + ": " + other.credit + " (" + other.pct + "%)" +
                          "\nDifference: " + dTxt + " of the total") : "");
      return '<div class="mta-col' + (i===0?' is-top':'') + '" data-tip="' + tip + '">' +
        '<div class="mta-cdelta' + dCls + '">' + esc(dTxt) + '</div>' +
        '<div class="mta-cbars">' +
          (other ? '<span class="mta-cb ghost" style="height:' + h2.toFixed(1) + '%"></span>' : '') +
          '<span class="mta-cb main" style="height:' + h1.toFixed(1) + '%;background:' + col(c.channel) + '"></span>' +
        '</div>' +
        '<div class="mta-cval">' + c.pct + '%</div>' +
        '<div class="mta-clab">' + esc(c.channel) + '</div>' +
      '</div>';
    }).join("");

    host.innerHTML = '<div class="mta-cols">' + cols + '</div>' +
      '<div class="mta-btot gs-muted">' + chans.length + ' channel' + (chans.length===1?'':'s') +
      ' \u00b7 ' + (Math.round(total*100)/100) + ' credited conversions' +
      (cmp ? ' \u00b7 solid = ' + esc(modelLabel(mo)) + ', outline = ' + esc(cmpLabel(cmpKey)) +
             ', pp = difference in share' : '') + '</div>';
  }
  function renderComparison(){
    var tb=q("cmp-tbody"), rows=DATA.comparison||[];
    function mtaCmpRow(r){
      return '<tr><td class="ch"><span class="mta-dot" style="background:'+col(r.channel)+'"></span>'+esc(r.channel)+"</td>"+
        '<td class="r">'+r.first+"</td><td class=\"r\">"+r.last+"</td><td class=\"r hl\">"+r.linear+"</td><td class=\"r\">"+r.time_decay+"</td><td class=\"r\">"+r.position+"</td></tr>";
    }
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:6, items:rows, pageSize:20, emptyText:TR('multit.g.no_data'), render:mtaCmpRow });
    else tb.innerHTML = rows.length ? rows.map(mtaCmpRow).join("") : '<tr><td colspan="6" class="empty">'+TR('multit.g.no_data')+'</td></tr>';
  }
  function renderPaths(){
    var host=q("paths"), paths=DATA.paths||[];
    host.innerHTML= paths.length ? paths.map(function(p){
      var chips=(p.channels||[]).map(function(c){ return '<span class="mta-chip" style="background:'+col(c)+'22;color:'+col(c)+';border-color:'+col(c)+'55">'+esc(c)+"</span>"; }).join('<span class="mta-arrow">\u2192</span>');
      return '<div class="mta-path"><div class="mta-seq">'+chips+'</div><div class="mta-pmeta"><span class="mta-cnt">'+p.conversions+"\u00d7</span>"+(p.revenue>0?' <span class="mta-rev">'+p.revenue.toLocaleString(undefined,{minimumFractionDigits:2})+"</span>":"")+"</div></div>";
    }).join("") : '<div class="empty">'+TR('multit.f2.no_conversion_paths_in_this_range')+'</div>';
  }

  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_mta_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_mta_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; load(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_multi-touch-attribution_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }
  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    var rf=q("refresh"); if(rf)rf.addEventListener("click",load);
    var sel=q("model-sel"); if(sel)sel.addEventListener("change",function(){ if(DATA)renderModel(sel.value); });
    /* Changing the comparison redraws the same model against a different reference. */
    var cs=q("cmp-sel"); if(cs)cs.addEventListener("change",function(){ if(DATA)renderModel(currentModel()); });
    initRange(); load();
  }
  ready(init);
})();
